'use strict';


import {Component,Inject, Input} from 'ng-metadata/core';
import {PrimolyticsService, beacon} from '../../../analytics/primolytics.service';
import {FacetService} from '../facet.service';
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
import {getInstitutionCode, getVid, getAttributesMap} from '../../../appConfig/appConfigForward'
import {SmoothScrollUtil} from "../../../nddUtils/smoothScrollUtil.service";
import  {FilterInstitution} from '../../../nddUtils/filterInstitution.service'
import {SearchService} from "../../search.service";
import {FilterLanguage} from "../../../nddUtils/filterLanguage.service";
import {STATE_NAMES} from "../../../primoExplore/primoExploreStates.module";
import {NewspapersService} from '../../../newspapers/newspapers.service';
import {MediaQueries} from "../../../infra/mediaQueries.service";



const map  = require('lodash/map');
const replace  = require('lodash/replace');
const _escape = require('lodash/escape');
var angular: angular.IAngularStatic = require('angular');


@Component({
    selector: 'prm-facet-exact',
    templateUrl: 'components/search/facet/facetExact/facet-exact.html',
})



export class  PrmFacetExact{
    @Input() facetGroup: any;

    private _facetGroupHeader: string;
    private vid = getVid();


    constructor(private configurationUtil : ConfigurationUtil,
                private facetService:FacetService,
                private primolyticsService: PrimolyticsService,
                @Inject('$filter') private $filter: ng.IFilterService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$translate')  private $translate:ng.translate.ITranslateService,
                @Inject('facetsIcons') public facetsIcons: any,
                @Inject('availabilityLineIcons') private availabilityLineIcons,
                @Inject('$state') private $state: angular.ui.IStateService,
                private filterInstitution: FilterInstitution,
                private smoothScrollUtil: SmoothScrollUtil,
                private searchService:SearchService,
                private filterLanguage:FilterLanguage,
                private newspapersService: NewspapersService,
                @Inject('$interval') private $interval: ng.IIntervalService,
                private mediaQueries: MediaQueries) {

        this.$translate('facets.facet.facet_'+ this.facetGroup.name).then((translation)=>{
            if (translation){
                this._facetGroupHeader= translation;
            }
            else{
                this._facetGroupHeader= this.facetGroup.name;
            }
        });
    }

    ngOnInit(){
    }


    public addFacet(facet){
        if (this.facetGroupHeader == 'Collection') {
            this.runCollectionDiscoveryBeacon();
        }

        if (facet.mergedFacets){
            this.facetService.clearMultiFacets();
            this.toggleMultiFacet(facet);
            this.facetService.applyMultiFacets();
        }
        else{
            this.doFacetSearch(facet.name,facet.value, facet.value,'include',this.facetGroup.displayedType, 'add');
        }
    }

    @beacon({ 'p': 'colldisc', 'op': 'refine' })
    private runCollectionDiscoveryBeacon() {}
    /**
     * @ngdoc method
     * @name addFacet
     * @methodOf starter.controller:FacetController
     * @description
     * Add facet to query and perform a new search
     * Performs a search together with facets
     * @param {string} name - The facet name selected
     * @param {string} value - The facet value to search
     */
    @beacon({'p': 'refine'})
    public doFacetSearch(name, label, value, facetType, displayedType, operation) {
        let facetString= name+','+facetType+','+value;
        this.facetService.facetSearch({facet: facetString});

    }

    //UI visible elements
    public isShowMore(facet) {
        if (!facet) {
            return false;
        }
        return facet.limitCount > 0 && facet.displayedCount < facet.values.length;
    }


    public toggleFacet(event) {
        let elem = event.target;
        this.facetGroup.facetGroupCollapsed = !this.facetGroup.facetGroupCollapsed;
        elem.setAttribute('aria-expanded', this.facetGroup.facetGroupCollapsed);
        //Loading facets in bulks of 10.
        let limit = this.facetGroup.limitCount === 0 ? this.facetGroup.values.length : this.facetGroup.limitCount;
        this.facetGroup.displayedCount = Math.min(10, limit);
        let interval = this.$interval(()=>{
            if (this.facetGroup.displayedCount >= limit){
                this.$interval.cancel(interval);
                this.facetGroup.displayedCount = limit;
            }
            else{
                this.facetGroup.displayedCount = Math.min(this.facetGroup.displayedCount + 10, limit);
            }
        }, 500);
    }

    public toggleMoreFacets(facet,isKeyPress=0) {
        facet.displayedCount = facet.displayedCount === facet.limitCount ? facet.values.length : facet.limitCount;
        if (isKeyPress) {
            let ontSetTimeout = function () {
                let facetElements = document.getElementsByClassName('facet-element-marker-' + facet.name);
                if (facetElements.length > facet.limitCount) {
                    let lastFacet = <HTMLLinkElement>facetElements[facet.limitCount];
                    this.smoothScrollUtil.elementFocus(lastFacet);
                    this.smoothScrollUtil.elementFocus(lastFacet);
                }
            };

            this.$timeout(ontSetTimeout.bind(this), 300);
            // this.$scope.$watchCollection(()=> {
            //     return document.getElementsByClassName('facet-element-marker-' + facet.name)
            // }, ontSetTimeout.bind(this))

        }
    }

    getFacetGroupValues(){
        return this.filterInstitution.filterAndNormalizeDataFacets(this.facetGroup.values);

    }

    public facetLabel(facet) {
        return this.facetService.facetLabel(facet);
    }

    public getCountsummary(facet) {
        if (!facet.maxCount) {
            return this.$filter('number')(facet.count);
        }

        let placeHolders = {
            idx_0: this.$filter('number')(facet.count),
            idx_1: this.$filter('number')(facet.maxCount)
        };

        let label = this.$translate.instant('nui.facets.remote.collection', placeHolders);

        return label;

    }

    private isShowCount(facet) {
        if(this.configurationUtil.getBackendSystem() === 'suprima'){
            if("tlevel" === facet.name || "newrecords" === facet.name){
                return false;
            }
        }

        if("tlevel" === facet.name && "open_access" === facet.value){
            return false;
        }
        return true;
    }

    get facetGroupHeader () {
        return this._facetGroupHeader;
    }

    public toggleMultiFacet(facet) {
        this.facetService.toggleMultiFacet(facet);
    }

    public toggleIncludeExclude(facet) {
        this.runFacetIncludeExcludeBeacon();
        this.facetService.toggleIncludeExclude(facet);
    }

    @beacon({ 'p': 'refine'})
    public runFacetIncludeExcludeBeacon() {}

    public containLegalFacetByLang(facet):boolean{

        if(!this.checkLang(facet.displayValue || facet.value)){
            return false;
        }
        if(!this.checkLang(this.facetLabel(facet))){
            return false;
        }
        return true;

    }

    public checkLang(facetdisplay:string){
        return this.filterLanguage.checkLang(facetdisplay);
    }


    public removeNotRelevantChars(facet:string):string{
        return this.filterLanguage.removeNotRelevantChars(facet);

    }

    public escapeHtmlChars(s:string){
        return _escape(s);
    }

    public ariaLabelForFacet(facetType) {
        if (facetType === 'exclude') {
            return this.$translate.instant('nui.facets.exclude.tooltip');
        }
        else {
            return this.$translate.instant('nui.facets.include.tooltip');
        }
    }

    public getFacetTitleTranslated(facet) {
        return this.facetService.getFacetTitleTranslated(facet, this.facetGroup);
    }

    private isRtypeFacet(facet) {
        return facet === 'rtype';
    }


    private displayNewspapersLink() {
        return this.newspapersService.displayNewspapersLink();
    }

    public isLocalFacet(){
        return this.facetGroup.name.startsWith('lds') && this.configurationUtil.getBackendSystem() === 'suprima';
    }

    
    public getTranslatedLocationWithLibraryName(facet){
        return this.facetService.getFacetTitleTranslated(facet,this.facetGroup);
    }

    public ariaLabelForFacetCheckbox(facet){
        if (!this.$translate.isReady()){
            return undefined;
        }
        let facetTitleString = this.getFacetTitleTranslated(facet);
        return `${this.ariaLabelForFacet(facet.facetType)} ${facetTitleString} ${this.$translate.instant('nui.multiple.selection')}`;
    }
    public ariaLabelForFacetTitle(facet){
        if (!this.$translate.isReady()){
            return undefined;
        }
        let facetTitleTranslated = this.getFacetTitleTranslated(facet);
        return `${facetTitleTranslated} ${this.getCountsummary(facet)} ${this.$translate.instant('nui.facets.searchResults')}`;
    }

    get facetToLeft() {
        let viewConfig = getAttributesMap();
        return viewConfig['selectedFacetLocation'] === 'left';
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facetExact/facetExact.directive.ts